var _g, _g2, _circle, _g3, _g4, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhysicsicon = function SvgPhysicsicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.7,
    cy: 75,
    strokeWidth: 6.342,
    rx: 34.9,
    ry: 70.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 74.2,
    strokeWidth: 6.623,
    rx: 84.2,
    ry: 34.5,
    transform: "rotate(-41.574 74.993 74.167)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 74.2,
    strokeWidth: 6.658,
    rx: 34.5,
    ry: 84,
    transform: "rotate(-47.423 74.994 74.168)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "props.stroke",
    stroke: "#fff",
    strokeWidth: 1.012
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 18.2,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 133.3,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.9,
    cy: 16.7,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.7,
    cy: 113.6,
    r: 8.2
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 23.1,
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "props.stroke"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.3,
    cy: 65.5,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.8,
    cy: 86.7,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 65.5,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.4,
    cy: 77.9,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.3,
    cy: 78.9,
    r: 6.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "props.color"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68.8,
    cy: 85.1,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.3,
    cy: 84.6,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 62.1,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.3,
    cy: 71.7,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.6,
    cy: 70.5,
    r: 6.2
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.3,
    cy: 76.2,
    r: 6.2,
    fill: "props.stroke"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.1,
    cy: 76.7,
    r: 6.2,
    fill: "props.color"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.3,
    cy: 73.2,
    r: 6.2,
    fill: "props.stroke"
  })));
};
export default SvgPhysicsicon;